
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Snackbar from '@/components/Snackbar.vue'
import Toolbar from "@/components/Toolbar.vue"
import Navigation from "@/components/Navigation.vue"

@Component({
  components: {
    Navigation,
    Toolbar,
    Snackbar
  }
})
export default class App extends Vue {
  private showNavigation = !this.$vuetify.breakpoint.mobile

  get BaseStyling () {
    if (this.$store.getters["account/user"] && this.showNavigation) {
      return 'margin-left: 65px; margin-top: 10px; margin-right: 15px; height: 100%'
    }
    return ''
  }

  private hideNavigation () {
    if (this.showNavigation) {
      this.showNavigation = false
    }
  }
}

